module.exports = __webpack_public_path__ + "static/record-f8aefda2eb1d51565a4499ce53ea6d30.jpg";